import feathers from '@feathersjs/client';
import { config } from '../utils/utils';
import axios from 'axios';
import rest from "@feathersjs/rest-client";
import { toastHandler } from '../utils/toastHandler';

export const feathersClient = feathers();

// For GET requests
axios.interceptors.request.use(
    (req: any) => {
        // Add configurations here
        const authKey = localStorage.getItem(config.AUTH_KEY);
        if (authKey) {
            req.headers.Authorization = `Bearer ${authKey}`;
        }
        return req;
    },
    (err) => {
        toastHandler(err?.response?.data);
        return Promise.reject(err);
    }
);

const restClient = rest(config.BASE_URL);
feathersClient.configure(restClient.axios(axios));
feathersClient.configure(feathers.authentication());

feathersClient.configure(
    feathers.authentication({
        storageKey: config.AUTH_KEY,
        storage: window.localStorage,
    })
);
